import React, { useEffect, useState } from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import { GraduationCap, Award, Star, CheckCircle } from 'lucide-react';

const doctors = [
  {
    id: 1,
    name: "Dr. Marco Rossi",
    title: "Direttore Sanitario",
    specialization: "Chirurgia Refrattiva e della Cataratta",
    education: [
      "Laurea in Medicina e Chirurgia - Università di Milano",
      "Specializzazione in Oftalmologia - Università Vita-Salute San Raffaele",
      "Fellowship in Chirurgia Refrattiva - Bascom Palmer Eye Institute, Miami"
    ],
    experience: "25 anni di esperienza",
    focus: ["LASIK e PRK", "Chirurgia della Cataratta Premium", "Lenti Intraoculari Multifocali"],
    image: "https://images.pexels.com/photos/5327584/pexels-photo-5327584.jpeg"
  },
  {
    id: 2,
    name: "Dr.ssa Elena Bianchi",
    title: "Responsabile Retina Medica",
    specialization: "Patologie della Retina e Maculopatie",
    education: [
      "Laurea in Medicina - Università degli Studi di Roma La Sapienza",
      "Specializzazione in Oftalmologia - Università Campus Bio-Medico",
      "Master in Malattie Retiniche - Moorfields Eye Hospital, Londra"
    ],
    experience: "18 anni di esperienza",
    focus: ["Degenerazione Maculare", "Retinopatia Diabetica", "Iniezioni Intravitreali"],
    image: "https://images.pexels.com/photos/5215024/pexels-photo-5215024.jpeg"
  },
  {
    id: 3,
    name: "Dr. Alessandro Verdi",
    title: "Specialista in Glaucoma",
    specialization: "Glaucoma e Chirurgia del Segmento Anteriore",
    education: [
      "Laurea in Medicina e Chirurgia - Università di Padova",
      "Specializzazione in Oftalmologia - Università di Firenze",
      "Fellowship in Glaucoma - Wilmer Eye Institute, Johns Hopkins, USA"
    ],
    experience: "15 anni di esperienza",
    focus: ["Diagnosi Precoce del Glaucoma", "Chirurgia Mini-Invasiva (MIGS)", "Laser SLT"],
    image: "https://images.pexels.com/photos/5407206/pexels-photo-5407206.jpeg"
  },
  {
    id: 4,
    name: "Dr.ssa Giulia Conti",
    title: "Ortottista e Specialista Strabismo",
    specialization: "Strabismo e Neuroftalmologia Pediatrica",
    education: [
      "Laurea in Medicina - Università di Bologna",
      "Specializzazione in Oftalmologia - Policlinico S. Orsola-Malpighi",
      "Diploma di Ortottica - Università di Torino"
    ],
    experience: "12 anni di esperienza",
    focus: ["Strabismo Infantile e Adulto", "Ambliopia", "Riabilitazione Visiva"],
    image: "https://images.pexels.com/photos/5327921/pexels-photo-5327921.jpeg"
  },
  {
    id: 5,
    name: "Dr. Luca Marini",
    title: "Specialista Cornea",
    specialization: "Patologie della Cornea e Trapianti",
    education: [
      "Laurea in Medicina - Università di Napoli Federico II",
      "Specializzazione in Oftalmologia - Università di Siena",
      "Fellowship in Cornea - Massachusetts Eye and Ear, Boston"
    ],
    experience: "14 anni di esperienza",
    focus: ["Cheratocono", "Cross-linking Corneale", "Trapianto di Cornea (DMEK, DSAEK)"],
    image: "https://images.pexels.com/photos/6303560/pexels-photo-6303560.jpeg"
  }
];

export const Equipe = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(160deg, #eaf5fc 0%, #f7fbfe 50%, #e1eef8 100%)' }}>
      <Navbar />
      
      {/* Hero Section - Luxury Style */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%232A9FCB' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
        
        <div className="max-w-5xl mx-auto px-4 text-center relative z-10">
          <span 
            className={`inline-block px-6 py-2 rounded-full text-sm font-medium tracking-widest uppercase mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            style={{ background: 'rgba(42, 159, 203, 0.1)', color: '#2A9FCB', fontFamily: "'Manrope', sans-serif" }}
          >
            Il Nostro Team
          </span>
          <h1 
            className={`text-4xl sm:text-5xl lg:text-6xl mb-6 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            style={{ fontFamily: "'Playfair Display', Georgia, serif", color: '#1A1A1A' }}
          >
            L'Équipe Medica
          </h1>
          <p 
            className={`text-lg sm:text-xl max-w-2xl mx-auto transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            style={{ fontFamily: "'Manrope', sans-serif", color: '#666666' }}
          >
            Professionisti d'eccellenza al servizio della vostra vista, 
            con formazione internazionale e anni di esperienza.
          </p>
        </div>
      </section>

      {/* Team Grid - Luxury Cards */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid gap-16">
            {doctors.map((doctor, index) => (
              <div 
                key={doctor.id}
                className={`grid md:grid-cols-3 gap-10 items-start ${index % 2 === 1 ? 'md:direction-rtl' : ''}`}
              >
                {/* Image */}
                <div className={`${index % 2 === 1 ? 'md:order-2' : ''}`}>
                  <div className="relative group">
                    <div 
                      className="absolute inset-0 rounded-3xl transform rotate-3 transition-transform group-hover:rotate-6"
                      style={{ background: '#2A9FCB', opacity: 0.1 }}
                    />
                    <img 
                      src={doctor.image} 
                      alt={doctor.name}
                      className="relative w-full h-96 object-cover rounded-3xl shadow-[0_8px_40px_rgba(0,0,0,0.1)] transition-transform duration-500 group-hover:scale-[1.02]"
                      style={{objectPosition: 'top'}}
                    />
                    <div 
                      className="absolute -bottom-5 -right-5 w-20 h-20 rounded-2xl flex items-center justify-center shadow-xl"
                      style={{ background: '#2A9FCB' }}
                    >
                      <Award className="w-10 h-10 text-white" />
                    </div>
                  </div>
                </div>
                
                {/* Content */}
                <div className={`md:col-span-2 ${index % 2 === 1 ? 'md:order-1 md:text-right' : ''}`}>
                  <span 
                    className="inline-block px-5 py-2 rounded-full text-sm font-medium mb-5"
                    style={{ 
                      background: 'rgba(42, 159, 203, 0.1)', 
                      color: '#2A9FCB',
                      fontFamily: "'Manrope', sans-serif"
                    }}
                  >
                    {doctor.title}
                  </span>
                  <h2 
                    className="text-3xl sm:text-4xl mb-3"
                    style={{ fontFamily: "'Playfair Display', Georgia, serif", color: '#1A1A1A' }}
                  >
                    {doctor.name}
                  </h2>
                  <p 
                    className="text-lg mb-2"
                    style={{ fontFamily: "'Manrope', sans-serif", color: '#2A9FCB' }}
                  >
                    {doctor.specialization}
                  </p>
                  <p 
                    className="text-sm mb-8 flex items-center gap-2"
                    style={{ 
                      color: '#666666',
                      fontFamily: "'Manrope', sans-serif",
                      justifyContent: index % 2 === 1 ? 'flex-end' : 'flex-start'
                    }}
                  >
                    <Star className="w-4 h-4 text-amber-500" />
                    {doctor.experience}
                  </p>
                  
                  {/* Education */}
                  <div className={`mb-8 ${index % 2 === 1 ? 'md:ml-auto md:text-left' : ''}`} style={{maxWidth: '550px'}}>
                    <h4 
                      className={`flex items-center gap-3 font-semibold mb-4 ${index % 2 === 1 ? 'md:justify-end' : ''}`}
                      style={{ color: '#1A1A1A', fontFamily: "'Playfair Display', Georgia, serif" }}
                    >
                      <GraduationCap className="w-5 h-5 text-[#2A9FCB]" />
                      Formazione
                    </h4>
                    <ul className="space-y-3">
                      {doctor.education.map((edu, i) => (
                        <li 
                          key={i} 
                          className="text-sm pl-5 border-l-2 py-1"
                          style={{ 
                            borderColor: '#2A9FCB', 
                            color: '#666666',
                            fontFamily: "'Manrope', sans-serif"
                          }}
                        >
                          {edu}
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  {/* Areas of Focus */}
                  <div className={`${index % 2 === 1 ? 'md:ml-auto' : ''}`} style={{maxWidth: '550px'}}>
                    <h4 
                      className={`font-semibold mb-4 ${index % 2 === 1 ? 'md:text-right' : ''}`}
                      style={{ color: '#1A1A1A', fontFamily: "'Playfair Display', Georgia, serif" }}
                    >
                      Aree di Specializzazione
                    </h4>
                    <div className={`flex flex-wrap gap-2 ${index % 2 === 1 ? 'md:justify-end' : ''}`}>
                      {doctor.focus.map((area, i) => (
                        <span 
                          key={i}
                          className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm"
                          style={{ 
                            background: 'linear-gradient(160deg, #eaf5fc 0%, #f7fbfe 50%, #e1eef8 100%)', 
                            color: '#1A1A1A',
                            border: '1px solid #E5E7EB',
                            fontFamily: "'Manrope', sans-serif"
                          }}
                        >
                          <CheckCircle className="w-4 h-4 text-[#2A9FCB]" />
                          {area}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20" style={{ background: '#2A9FCB' }}>
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 
            className="text-3xl sm:text-4xl text-white mb-6"
            style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
          >
            Prenota una Visita con i Nostri Specialisti
          </h2>
          <p 
            className="text-white/80 text-lg mb-8 max-w-2xl mx-auto"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Il nostro team è a tua disposizione per una consulenza personalizzata.
          </p>
          <a 
            href="/prenota" 
            className="inline-flex items-center justify-center bg-white text-[#2A9FCB] hover:bg-gray-100 rounded-full px-10 py-4 text-sm font-semibold transition-all duration-300 shadow-lg"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Prenota Ora
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Equipe;
